import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import LowStockBanner from "./components/LowStockBanner";
import NewsletterPopup from "./components/NewsletterPopup";
import { CartProvider } from "./context/CartContext";
import Builder from "./pages/Builder";
import Cart from "./pages/Cart";
import Account from "./pages/Account";
import About from "./pages/About";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App min-h-screen bg-white text-black">
      <BrowserRouter>
        <CartProvider>
        <LowStockBanner />
        <Header />
        <Routes>
          <Route path="/" element={<Builder />} />
          <Route path="/blends" element={<Navigate to="/" replace />} />
          <Route path="/events" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <NewsletterPopup />
        <footer className="border-t border-black/15 mt-10">
          <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-8 text-xs text-black/60">
            <span className="overline">© Briology</span>
          </div>
        </footer>
        <Toaster position="bottom-right" />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
